import { useMemo } from 'react'
import { setLocale } from 'react-i18nify'
import { useParams } from 'react-router-dom'
import { campaign } from '../campaigns'

interface UseTranslationsReturnType {
  current: string | undefined
  all: {
    [key: string]: string
  }
}

export const useTranslations = (customLocales?: any): UseTranslationsReturnType => {
  const { lang } = useParams()

  // Default to the active campaign's locales so language pickers only list the
  // languages actually available for this campaign.
  const localesToUse = customLocales || campaign.formLocales
  const allLocales = useMemo(
    () =>
      Object.keys(localesToUse).reduce((acc, current) => {
        // Guard against locale files missing the meta block
        //@ts-expect-error
        acc[current] = localesToUse[current]?.meta?.lang
        return acc
      }, {}),
    [localesToUse],
  )
  setLocale(lang && localesToUse[lang] ? lang : 'en')

  return { current: lang, all: allLocales }
}
